import { render, staticRenderFns } from "./shexiang-keyan.vue?vue&type=template&id=c324890e&"
import script from "./shexiang-keyan.vue?vue&type=script&lang=ts&"
export * from "./shexiang-keyan.vue?vue&type=script&lang=ts&"
import style0 from "./shexiang-keyan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports